<template>
  <b-modal id="change_applicant_status" ref="change_applicant_status" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-user-cog"></i> <span>Change applicant status</span></h1>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <h4>Application details</h4>
    <div class="row mb-4">
      <div class="col-4"><strong>Name</strong></div>
      <div class="col-8">{{$store.state.applicants.status_modal.applicant_dt_row_data.full_name}}</div>
      <div class="col-4"><strong>Current status</strong></div>
      <div class="col-8">{{$store.state.applicants.status_modal.applicant_dt_row_data.application_status}}</div>
      <div class="col-12">&nbsp;</div>
      <div class="col-4"><strong>Job Ref</strong></div>
      <div class="col-8">{{$store.state.applicants.status_modal.applicant_dt_row_data.order_ref}}</div>
      <div class="col-4"><strong>Job title</strong></div>
      <div class="col-8">{{$store.state.applicants.status_modal.applicant_dt_row_data.job_title}}</div>
    </div>
    <ValidationObserver ref="applicationStatusRef" slim>
      <form role="form" @submit.prevent="submit_form" class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" name="Application status" tag="div" class="col-12 form-group">
          <label class="form-label" for="application_status">Application status</label>
          <multiselect v-model="application_status" id="application_status" name="application_status" placeholder=""
                       :options="ms_opts.application_status" label="value" class="requiredField" :class="classes"></multiselect>
          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
        </ValidationProvider>

        <div class="col-6 offset-6">
          <button class="btn orcaBtn w-100 mt-3">Update</button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "change_applicant_status",
  components: {
    Multiselect
  },
  data() {
    return {
      ms_opts: {
        application_status: []
      },
      application_status: null
    }
  },
  beforeMount() {
    // Get application statuses
    axios.get(this.crmApiPath + 'crm/attributes/worker_application_status').then(statuses => {
      this.ms_opts.application_status = statuses.data
      // if current status is 'Contacted' don't allow status to be changed to 'New'
      if (this.$store.state.applicants.status_modal.applicant_dt_row_data.application_status === 'New') {
        let pos = this.ms_opts.application_status.map(function(e) { return e.value; }).indexOf('New')
        this.ms_opts.application_status.splice(pos, 1)
      }
      // if current status is 'Contacted' don't allow status to be changed to 'New' OR 'Contacted'
      else if (this.$store.state.applicants.status_modal.applicant_dt_row_data.application_status === 'Contacted') {
        let pos = this.ms_opts.application_status.map(function(e) { return e.value; }).indexOf('New')
        this.ms_opts.application_status.splice(pos, 1)
        pos = this.ms_opts.application_status.map(function(e) { return e.value; }).indexOf('Contacted')
        this.ms_opts.application_status.splice(pos, 1)
      }
    })
  },
  methods: {
    hideModal() {
      this.$refs.change_applicant_status.hide();
      this.$store.commit('HIDE_APPLICANT_STATUS_CHANGE_MODAL');
    },
    submit_form() {
      this.$refs.applicationStatusRef.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.applicationStatusRef);
        }
        else {
          axios.patch(this.crmApiPath + 'applications/status/' + this.$store.state.applicants.status_modal.application.id, {
            application_status_id: this.application_status.id,
            application_changed_by_id: this.$store.state.auth.me.id
          }).then(() => {
            // refresh table contents
            this.$bus.$emit("applications::get")
            this.hideModal()
          })

        }
      })

    }
  }
}
</script>

<style scoped>

</style>
